import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    '@font-face': [
      {
        fontFamily: 'SourceSansProSemiBold',
        src: "url('/static/fonts/SourceSansPro-SemiBold.ttf')"
      },
      {
        fontFamily: 'SourceSansProRegular',
        src: "url('/static/fonts/SourceSansPro-Regular.ttf')"
      }
    ],
    '@global': {
      '*': {
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
        fontFamily: 'SourceSansProRegular'
      },
      html: {
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        height: '100%',
        width: '100%'
      },
      body: {
        backgroundColor: '#f4f6f8',
        height: '100%',
        width: '100%',
        color: '#fff'
      },
      a: {
        textDecoration: 'none'
      },
      '#root': {
        height: '100%',
        width: '100%'
      }
    }
  })
);

const GlobalStyles = () => {
  useStyles();

  return null;
};

export default GlobalStyles;
